var map = {
	"./Algeria.png": 169,
	"./Angola.png": 170,
	"./Benin.png": 171,
	"./Botswana.png": 172,
	"./Burkina Faso.png": 173,
	"./Burundi.png": 174,
	"./Cameroon.png": 175,
	"./Central African Republic.png": 176,
	"./Central.png": 177,
	"./Chad.png": 178,
	"./Congo.png": 179,
	"./Continent.png": 180,
	"./Cote d_Ivoire.png": 181,
	"./Djibouti.png": 182,
	"./East.png": 183,
	"./Egypt.png": 184,
	"./Equatorial Guinea.png": 185,
	"./Eritrea.png": 186,
	"./Ethiopia.png": 187,
	"./Gabon.png": 188,
	"./Gambia.png": 189,
	"./Ghana.png": 190,
	"./Guinea Bissau.png": 191,
	"./Kenya.png": 192,
	"./Liberia.png": 193,
	"./Libya.png": 194,
	"./Madagascar.png": 195,
	"./Malawi.png": 196,
	"./Mali.png": 197,
	"./Mauritania.png": 198,
	"./Morocco.png": 199,
	"./Mozambique.png": 200,
	"./Namibia.png": 201,
	"./Niger.png": 202,
	"./Nigeria.png": 203,
	"./North.png": 204,
	"./Rwanda.png": 205,
	"./Senegal.png": 206,
	"./Sierra Leone.png": 207,
	"./Somalia.png": 208,
	"./South Africa.png": 209,
	"./South Sudan.png": 210,
	"./South.png": 211,
	"./Sudan.png": 212,
	"./Tanzania.png": 213,
	"./Togo.png": 214,
	"./Tunisia.png": 215,
	"./Uganda.png": 216,
	"./West.png": 217,
	"./Western Sahara.png": 218,
	"./Zambia.png": 219,
	"./Zimbabwe.png": 220
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 168;